// frontend/src/components/McDropdownSingleUser.tsx
import { IMinUserDepricated } from "@mctypes/global.types";
import { IUserPartial } from "@schemas/issueSchema";
import React, { RefObject, useState } from "react";
import { Avatar, McDropdownBase } from "..";
import { filterPattern } from "../../app/utils";
import { IMcDropdownBase } from "../McDropdownBase/McDropdownBase";

type UserLike = IMinUserDepricated | IUserPartial;

type Props = {
  onChange: (selected: UserLike) => void;
  options: UserLike[];
  selected: UserLike;
  color?: string;
  filterActive?: boolean;
  container?: string | HTMLElement | RefObject<HTMLElement> | null;
} & Omit<IMcDropdownBase, "children">;

export const McDropdownSingleUser: React.FC<Props> = ({
  onChange,
  options,
  selected,
  color = "white",
  container,
  ...props
}) => {
  const [filterValue, setFilterValue] = useState<string>("");

  const matcher = filterValue ? filterPattern(filterValue) : null;

  return (
    <McDropdownBase
      onFilter={(val) => setFilterValue(val)}
      onToggle={() => setFilterValue("")}
      {...props}
      color={color}
      container={container}
    >
      <McDropdownBase.Display>
        <Avatar id={selected?._id} name={selected?.name} size={20} />
        <div className="truncateHeaderText">{selected?.name}</div>
      </McDropdownBase.Display>

      {options
        ?.filter((u) => u != null && (!matcher || matcher.test(u.name ?? "")))
        .map((u) => (
          <McDropdownBase.Option key={String(u._id)} selected={u._id === selected?._id} onClick={() => onChange(u)}>
            <div className="d-flex w-100 align-items-center">
              <Avatar id={u._id} name={u.name} size={20} />
              <div className="truncateHeaderText">{u.name}</div>
            </div>
          </McDropdownBase.Option>
        ))}
    </McDropdownBase>
  );
};

export default McDropdownSingleUser;
